import styled from 'styled-components';
export const ButtonDiv = styled.div.withConfig({
  displayName: "WrapperDiv__ButtonDiv",
  componentId: "sc-1p64pe5-0"
})(["display:flex;justify-content:space-around;padding:10px;min-width:180px;"]);
export const ConfirmModalDiv = styled.div.withConfig({
  displayName: "WrapperDiv__ConfirmModalDiv",
  componentId: "sc-1p64pe5-1"
})(["padding:10px;"]);
export const ModalText = styled.div.withConfig({
  displayName: "WrapperDiv__ModalText",
  componentId: "sc-1p64pe5-2"
})(["text-align:center;"]);